import {Coordinate} from 'charts/types';

function isBetween(a: number, [start, end]: [number, number]) {
  return a >= start && a <= end;
}

interface GridRange {
  xRange: [number, number];
  yRange: [number, number];
}
const COACHABLE_REPS: GridRange = {xRange: [0, 66], yRange: [33, 100]};
const SOLID_CONTRIBUTORS: GridRange = {xRange: [33, 66], yRange: [0, 33]};
const SUBJECT_MATTER_EXPERTS: GridRange = {xRange: [66, 100], yRange: [0, 33]};
const AWESOME_PEEPS: GridRange = {xRange: [66, 100], yRange: [0, 33]};

function hasOverlap(coords: Coordinate[], {xRange, yRange}: GridRange): boolean {
  return coords.some(({x, y}) => isBetween(x, xRange) && isBetween(y, yRange));
}

function allOverlap(coords: Coordinate[], {xRange, yRange}: GridRange): boolean {
  return coords.every(({x, y}) => isBetween(x, xRange) && isBetween(y, yRange));
}

/**
 * Returns the most interesting quadrant to highlight based on the entire data set
 */
export function getHighlightQuadrant(repCoords: Coordinate[]): GridRange {
  if (hasOverlap(repCoords, SOLID_CONTRIBUTORS)) return SOLID_CONTRIBUTORS;
  if (hasOverlap(repCoords, SUBJECT_MATTER_EXPERTS)) return SOLID_CONTRIBUTORS;
  if (allOverlap(repCoords, AWESOME_PEEPS)) return AWESOME_PEEPS;

  // otherwise, default to "coachable" info
  return COACHABLE_REPS;
}

export function shouldHighlightPoint({x, y}: Coordinate, {xRange, yRange}: GridRange): boolean {
  return isBetween(x, xRange) && isBetween(y, yRange);
}
